export default __webpack_public_path__ + "static/media/linkedin.97636eb9.svg";